import React from 'react';

/**
 * ErrorBoundary — catches JavaScript errors in child components and displays
 * a user-friendly fallback UI instead of a blank white screen.
 *
 * React error boundaries must be class components (hooks don't support them).
 */
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught:', error, errorInfo);
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-gray-50">
                    <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                        <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                    </div>
                    <h1 className="text-2xl font-bold text-gray-800 mb-2">
                        Щось пішло не так / Something went wrong
                    </h1>
                    <p className="text-gray-500 mb-8 max-w-md">
                        Спробуйте оновити сторінку або повернутися на головну.
                        <br />
                        Try refreshing the page or returning to the home page.
                    </p>
                    <div className="flex items-center gap-4">
                        <button
                            onClick={this.handleRetry}
                            className="px-6 py-3 bg-gold text-white font-semibold rounded-full hover:bg-gold-dark transition-colors shadow-md"
                        >
                            Спробувати знову / Retry
                        </button>
                        <a
                            href="/"
                            className="px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-full hover:bg-gray-100 transition-colors"
                        >
                            Головна / Home
                        </a>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

